import {h, Fragment} from "preact";

import "./OnAirSmall.scss";
import {forwardRef} from "preact/compat";
import {useQuery} from "@urql/preact";
import useNowPlaying from "../../lib/useNowPlaying";
import { useEffectEveryHourOnTheHour } from "../../lib/useEffectEveryHourOnTheHour";

const OnAirQuery = `
    query {
        currentAndNext {
            current {
              ... on Timeslot{
                title
                season {
                  show {
                    photo
                  }
                }
              }
              ... on CurrentAndNext_PseudoTimeslot {
                title
                photo
              }
            }
          }
    }
`;

interface OnAirInfo {
    currentAndNext: {
        current:
            | { title: string, season: { show: { photo: string } } }
            | { title: string, photo: string }
    }
}

const OnAirSmall = forwardRef<HTMLDivElement, { visible: boolean }>((props, ref) => {
    const [result, refetch] = useQuery<OnAirInfo>({
        query: OnAirQuery,
        requestPolicy: 'network-only'
    });
    useEffectEveryHourOnTheHour(refetch);
    const show = result.data?.currentAndNext.current;

    const [trackNow, trackData] = useNowPlaying();
    return (
        <div class={"on-air-small-wrapper" + (props.visible && !!result.data ? "" : " hidden")} ref={ref}>
            {show && (
                <Fragment>
                    <div class="on-air-small">
                        <img alt={"Show image for " + show.title}
                             src={"https://ury.org.uk" + ("photo" in show ? show.photo : show.season.show.photo)}/>
                        <span class="title">{show.title}</span>
                    </div>
                    {trackData !== null && (
                        <div class="now-playing-small">
                            <b>{trackNow ? "NOW PLAYING: " : "LAST PLAYED: "}</b>
                            {trackData.nowPlaying.track.title} - {trackData.nowPlaying.track.artist}
                        </div>
                    )}
                </Fragment>
            )}
        </div>
    );
});

export default OnAirSmall;
